import failIcon from "assets/img/icons/icon-warning.svg";

const QuickCraftFail = ({closeWindow}) => {
  return (
    <>
      <header className="modal-window__header">
        <img src={failIcon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Sorry!</h5>
        <p className="modal-window__info">The Identity wasn't crafted</p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-submit" onClick={closeWindow}>
          Continue
        </button>
      </footer>
    </>
  );
};

export default QuickCraftFail;
